import React from "react";
import { ArrowDownRight } from "lucide-react";
import { profile } from "../data/mock";

const Hero = () => {
  const scrollToWork = (e) => {
    e.preventDefault();
    const el = document.querySelector("#work");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 px-6 md:px-10 max-w-[1400px] mx-auto"
    >
      {/* Top meta row */}
      <div className="grid grid-cols-12 gap-4 mb-12 md:mb-20">
        <div className="col-span-6 md:col-span-3">
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64]">
            Portfolio
          </p>
        </div>
        <div className="col-span-6 md:col-span-3 md:col-start-10 text-right">
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64]">
            {profile.location}
          </p>
        </div>
      </div>

      {/* Massive name type */}
      <h1 className="font-display font-medium tracking-[-0.035em] text-[#0d0d0d] text-[16vw] md:text-[13.2vw] leading-[0.88]">
        Evan
        <span className="italic font-serif font-light tracking-[-0.02em]">
          {" "}Magee
        </span>
      </h1>

      {/* Bottom content row */}
      <div className="grid grid-cols-12 gap-4 mt-10 md:mt-14 items-end">
        <div className="col-span-12 md:col-span-4">
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64] mb-3">
            Role / 01
          </p>
          <ul className="text-[15px] md:text-base text-[#0d0d0d] leading-relaxed">
            {profile.roles.map((r) => (
              <li key={r} className="border-t border-[#d8d5cc] py-2">
                <span>{r}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="hidden md:block col-span-3" />

        <div className="col-span-12 md:col-span-5">
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64] mb-3">
            Statement / 02
          </p>
          <p className="text-[20px] md:text-[26px] leading-[1.25] text-[#0d0d0d] tracking-[-0.01em]">
            Producing, problem solving, and building visual languages for
            series, brands, and everything in between. For{" "}
            <span className="italic font-serif font-normal">
              Netflix, HBO, Discovery,
            </span>{" "}
            and beyond.
          </p>

          <a
            href="#work"
            onClick={scrollToWork}
            className="inline-flex items-center gap-2 mt-8 text-[13px] tracking-tight text-[#0d0d0d] group"
          >
            <span className="border-b border-[#0d0d0d] pb-0.5 group-hover:opacity-60 transition-opacity duration-200">
              View selective work
            </span>
            <ArrowDownRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:translate-y-0.5"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
